// extracted by mini-css-extract-plugin
export default {"root":"R2lgF4","content":"F8iMQV","contentHeader":"e3cyp9","title":"mW1ZAG","buttons":"B2YUVp"};